import type {ThunkAction} from 'src/reducers';
import type {
  // @ts-expect-error - TS2614 - Module '"src/api-parsers/index"' has no exported member 'AgencyOverview'. Did you mean to use 'import AgencyOverview from "src/api-parsers/index"' instead?
  AgencyOverview,
  // @ts-expect-error - TS2614 - Module '"src/api-parsers/index"' has no exported member 'AgencyOverviewAudienceMembers'. Did you mean to use 'import AgencyOverviewAudienceMembers from "src/api-parsers/index"' instead?
  AgencyOverviewAudienceMembers,
} from 'src/api-parsers/index';

import {thunkify as flow} from 'src/utils/thunks';
import {key, cached, fetching} from 'src/utils/redux';
import * as reduxApi from 'src/utils/redux-api';
import parsers from 'src/api-parsers/index';
import {
  checkAnalyticsLandingPageV3Enabled,
  ANALYTICS_API_V3,
} from 'src/utils/analytics-api-migration';


export const RECEIVE = 'agencyOverview/receive';
export const RECEIVE_ACTIVE_AUDIENCE = 'agencyOverview/receiveMembers';

export type ReceiveAgencyOverviewAction = {
  type: 'agencyOverview/receive';
  payload: AgencyOverview;
};

export type AgencyOverviewAudienceAction = {
  type: 'agencyOverview/receiveMembers';
  payload: AgencyOverviewAudienceMembers;
};

export type AgencyOverviewAction =
  | ReceiveAgencyOverviewAction
  | AgencyOverviewAudienceAction;

const {
  parse: {
    agencyOverview: agencyOverviewParser,
    agencyOverviewAudienceMembers: agencyOverviewMemberParser,
  },
} = parsers;

export const receive = (
  payload: AgencyOverview,
): ReceiveAgencyOverviewAction => ({
  type: RECEIVE,
  payload,
});

export const receiveAudienceMembers = (
  payload: AgencyOverviewAudienceMembers,
): AgencyOverviewAudienceAction => ({
  type: RECEIVE_ACTIVE_AUDIENCE,
  payload,
});

export const getAgencyOverview: () => ThunkAction<unknown> = flow(
  key(() => `agencyOverview`),
  cached((json) => receive(agencyOverviewParser(json)), {ttl: 10000}),
  fetching({}),
)(() =>
  reduxApi.get(
    `agency/overview`,
    {},
    {
      apiPath: checkAnalyticsLandingPageV3Enabled()
        ? `${ANALYTICS_API_V3}/`
        : '/api/v1/',
    },
  ),
);

// TODO (chris): Remove when multiEntityEnabled is deprecated
export const getAgencyOverviewAudienceMembers: () => ThunkAction<unknown> =
  flow(
    key(() => `agencyOverviewAudienceMembers`),
    cached((json) => receiveAudienceMembers(json), {}),
    fetching({}),
  )(() => reduxApi.get(`agency/active-members`));
